const Redis = process.client ? require('./clientRedis.ts') : require('./serverRedis.ts');

export default Redis;
